import { BrandIconSpinner, Button, UploadFiles } from 'components';
import React, { useEffect, useState } from 'react';
import { SubmitContainer } from './Profile.style';
import { Notification } from 'components/CustomNotification';
import { useDispatch, useSelector } from 'react-redux';
import { AddMoreStyle } from './AddProfile.style';
import {
  DeleteCmyImages,
  getCompanyImagesList,
  updateAndAddImages,
} from 'redux/features/CompanySlice';
import { ProfileLimit } from 'assert/OptionList';
import CustomCarousel from 'components/CustomCarousel';

export default function CompanyImages({ personalData, onClose }) {
  const dispatch = useDispatch();
  const { getProfile } = useSelector((state) => state?.ProfileSlice);

  const [loading, setLoading] = useState(false);
  const [states, setState] = useState({
    image: [],
  });

  const companyImg = personalData?.details?.[0]?.image;

  useEffect(() => {
    setState({
      image: companyImg || [],
    });
  }, [companyImg]);

  const handleChange = (data) => {
    const newImageUrls = [];
    const isExceedLength = data?.length > ProfileLimit?.companyMaxSize;
    if (isExceedLength) {
      Notification(
        'warning',
        `Cannot upload more then ${ProfileLimit?.companyMaxSize} Images`
      );
    }
    data.forEach((image, index) => {
      if (index < ProfileLimit?.companyMaxSize) {
        newImageUrls.push(image);
      }
    });
    setState((prevState) => ({
      ...prevState,
      image: newImageUrls,
    }));
  };

  const resetFields = () => {
    setState({
      image: [],
    });
    onClose(false, 'companyImages');
    setLoading(false);
  };

  const handleSubmit = () => {
    const fromData = new FormData();
    let hasValidImage = false;

    states?.image?.forEach((data) => {
      if (typeof data !== 'string') {
        hasValidImage = true;
        fromData.append('images', data);
      }
    });

    if (!hasValidImage) {
      Notification('warning', 'Please add atleast one new image to upload.');
      return;
    }
    setLoading(true);
    dispatch(updateAndAddImages(fromData, companyImg ? 'put' : 'post'))
      .then(() => {
        dispatch(getCompanyImagesList(getProfile?.username));
        resetFields();
        Notification('success', 'Updated Successfully');
      })
      .catch((err) => {
        resetFields();
        Notification('error', err.response?.data?.message);
      });
  };

  const handleDelete = (imgIndex) => {
    setLoading(true);
    dispatch(DeleteCmyImages(imgIndex, states?.image[imgIndex]))
      .then(() => {
        dispatch(getCompanyImagesList(getProfile?.username));
        setState((prevState) => ({
          ...prevState,
          image: states?.image?.filter((_, index) => {
            return index !== imgIndex;
          }),
        }));
        setLoading(false);
        Notification('success', 'Deleted Successfully');
      })
      .catch((err) => {
        setLoading(false);
        Notification('error', err.response?.data?.message);
      });
  };

  const hasValidImage = states?.image?.some((data) => typeof data !== 'string');

  return (
    <AddMoreStyle>
      <BrandIconSpinner loading={loading} />
      {states?.image?.length > 0 && (
        <CustomCarousel
          items={states?.image}
          autoPlay={false}
          handleDelete={handleDelete}
        />
      )}
      <div className="cmy-list-parent-div">
        <UploadFiles
          handleFileSRC={(data) => handleChange(data)}
          value={states.image}
          multiple
          accept={{ 'image/jpeg': ['.jpeg', '.png'] }}
          disabled={states.image?.length >= ProfileLimit.companyMaxSize}
        />
      </div>
      <SubmitContainer className="modal-footer">
        <Button
          label={'Submit'}
          onClick={handleSubmit}
          type={'text'}
          disabled={!hasValidImage}
        />
        <Button label={'Close'} onClick={resetFields} type={'text'} />
      </SubmitContainer>
    </AddMoreStyle>
  );
}
